import React, { useState, useEffect } from "react";
import axios from "axios";

import { ItemListResponse } from "helpers/interfaces";
import { TypeInfo } from "helpers/enums";

interface ITicketTypesContext {
    types: ITicketTypes[]
    isLoading: boolean

    setTypes: (v:ITicketTypes[])=> void
    getTypes: () => void
    deleteTicketType: (TypeId: string) => Promise<void>
}

export interface ITicketTypes {
    name: string
    id: string
    typeInfo: TypeInfo
}

export let ticketTypesContext = React.createContext<ITicketTypesContext>({} as ITicketTypesContext);

let { Provider } = ticketTypesContext;


let TicketTypeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {

    let [isLoading, setLoading] = useState(true);
    let [types, setTypes] = useState<ITicketTypes[]>([]);
    useEffect(() => {
        getTypes()
        
    }, [])


    let getTypes = async ()=>{
        try {
            setLoading(true);

            let response = await axios.get<ItemListResponse<ITicketTypes>>('/api/TicketType/GetTicketTypes');
            setTypes(response.data.items);

        } catch (error) { }
        finally {
            setLoading(false);
        }
    }

    let deleteTicketType = async (typeId: string) => {
        if (window.confirm("Are you sure that you want to remove this ticket Type?")) {
            try {
                await axios.delete(`/api/TicketType/DeleteTicketType/${typeId}`);
                setTypes(types.filter(type => type.name !== typeId));
                getTypes()

            } catch (err) { }
        }
    }

    return (
        <Provider value={{
            types,
            isLoading,
            
            setTypes,
            getTypes,
            deleteTicketType
        }}>
            {children}
        </Provider>
    );
};

export default TicketTypeProvider